import * as React from "react";
import type { SVGProps } from "react";
const SvgCardShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M1.8 15.413h-1zm0-9h1zm10.2 12.4a1 1 0 1 0 0-2v2m-7.8-1v-1zM21 6.412h-1zm-18.6.8a1 1 0 1 0 0 2v-2m18 2a1 1 0 1 0 0-2v2m-4.2 4.275-.447-.895a1 1 0 0 0-.553.895zm3 6.5-.534.845a1 1 0 0 0 1.068 0zm3-6.5h1a1 1 0 0 0-.553-.895zm-4.61-.696.447.895zm3.22 0-.447.895zM4.2 4.012v1h14.4v-2H4.2zm-2.4 11.4h1v-9h-2v9zm10.2 2.4v-1H4.2v2H12zm9-11.4h-1v1.8h2v-1.8zm-16.8-2.4v-1a3.4 3.4 0 0 0-3.4 3.4h2a1.4 1.4 0 0 1 1.4-1.4zm14.4 0v1a1.4 1.4 0 0 1 1.4 1.4h2a3.4 3.4 0 0 0-3.4-3.4zm-16.8 11.4h-1a3.4 3.4 0 0 0 3.4 3.4v-2a1.4 1.4 0 0 1-1.4-1.4zm.6-7.2v1h18v-2h-18zm15.19 4.58-.448-.894-1.39.695.448.895.447.894 1.39-.695zm-1.39.696h-1v3.345h2v-3.345zm0 3.345h-1c0 .845.49 1.57 1.058 2.156.59.606 1.416 1.218 2.408 1.844l.534-.845.534-.846c-.941-.594-1.614-1.107-2.042-1.547-.448-.461-.492-.703-.492-.762zm3 3.155.534.845c.952-.601 1.791-1.154 2.386-1.729.622-.601 1.08-1.328 1.08-2.271h-2c0 .21-.076.452-.47.834-.423.408-1.084.856-2.064 1.475zm3-3.155h1v-3.345h-2v3.344zm0-3.345.447-.895-1.39-.695-.447.894-.447.895 1.39.695zm-4.61-.696.447.895a2.6 2.6 0 0 1 2.326 0l.447-.895.447-.894a4.6 4.6 0 0 0-4.115 0z"
    />
  </svg>
);
export default SvgCardShield;
